const login = {
  path: 'login',
  component: resolve => require(['../../pages/login'], resolve)
}

export default login



// WEBPACK FOOTER //
// ./src/router/login/index.js